import { IProgram } from '@/types/program';
import urlJoin from 'url-join';

export function getProgramLink(program: IProgram) {
  return urlJoin(...[program.custom_campaign_domain || location.origin, '/programs', program.slug].filter(Boolean) as string[]);
}
